import {
  declareString,
  declareStringWithPlaceholders,
} from "@1js/localization";

export const PopoverTitle = declareString(
  "promptLibrary.workgroupOwnerTeachingPopoverTitle",
  {
    text: "Share prompts to your teams",
    comment: "Teaching Popover title to share a prompt to a workgroup.",
  }
);

export const PopoverMessage = declareStringWithPlaceholders(
  "promptLibrary.workgroupOwnerTeachingPopoverMessage",
  {
    text: ({ action }) =>
      `As team owner, you can help members get better results by using suggested or bookmarked prompts. Simply hover over a prompt and select ${action}.`,
    comment: "Teaching Popover message to share a prompt to a workgroup.",
    placeholders: {
      action: "Action to be displayed in bold is Share to team",
    },
  }
);

export const PopoverShareToTeam = declareString(
  "promptLibrary.workgroupOwnerTeachingPopoverShareToGroup",
  {
    text: "Share to team",
    comment:
      "Action to be displayed in bold in promptLibrary.workgroupOwnerTeachingPopoverMessage-resource instead of action-placeholder.",
  }
);

export const PopoverGotItButton = declareString(
  "promptLibrary.workgroupOwnerTeachingPopoverGotItButtonLabel",
  {
    text: "Got it",
    comment: "Action to dismiss the teaching popover.",
  }
);
